import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { ClubhouseAdKitDto } from "entities/responses/adkit";
import type {
  Clubhouse_AdKitImageDto,
  Clubhouse_AdKitMetaDataDto,
  SluggedId,
} from "Models";

export type AdKitState = {
  selectedAdKit: ClubhouseAdKitDto | null;
  selectedLocationId: SluggedId | null;
  adKitMetaData: Clubhouse_AdKitMetaDataDto[] | null;
  adKitImages: Clubhouse_AdKitImageDto[] | null;
  hasUnsyncedChanges: boolean;
};

const initialState: AdKitState = {
  selectedAdKit: null,
  selectedLocationId: null,
  adKitMetaData: null,
  adKitImages: null,
  hasUnsyncedChanges: false,
};

const slice = createSlice({
  name: "adkit",
  initialState,
  reducers: {
    setSelectedAdKit(
      state,
      action: PayloadAction<{
        selectedAdKit: ClubhouseAdKitDto;
      }>,
    ): void {
      state.selectedAdKit = action.payload.selectedAdKit;
    },
    setSelectedLocationId(
      state,
      action: PayloadAction<{
        selectedLocationId: SluggedId;
      }>,
    ): void {
      state.selectedLocationId = action.payload.selectedLocationId;
    },
    setAdKitMetaData(
      state,
      action: PayloadAction<{
        adKitMetaData: Clubhouse_AdKitMetaDataDto[];
      }>,
    ): void {
      state.adKitMetaData = action.payload.adKitMetaData;
    },
    setAdKitImages(
      state,
      action: PayloadAction<{
        adKitImages: Clubhouse_AdKitImageDto[];
      }>,
    ): void {
      state.adKitImages = action.payload.adKitImages;
    },
    setHasUnsyncedChanges(
      state,
      action: PayloadAction<{
        hasUnsyncedChanges: boolean;
      }>,
    ): void {
      state.hasUnsyncedChanges = action.payload.hasUnsyncedChanges;
    },
  },
});

const { actions, reducer: adKitReducer } = slice;

const {
  setSelectedAdKit,
  setAdKitMetaData,
  setAdKitImages,
  setSelectedLocationId,
  setHasUnsyncedChanges,
} = actions;

export {
  adKitReducer,
  setSelectedAdKit,
  setAdKitMetaData,
  setAdKitImages,
  setSelectedLocationId,
  setHasUnsyncedChanges,
};
